import React from 'react'
import './previewHeader.css'
export const PreviewHeader = (props) => {
    return (
        <>
            <header className={`header  ${props?.theme} preview-header`}>
                <div className='header-inner'>
                    <div className='menu'>
                        <div className='logo'>
                            <a id="site-link" href={props?.hasCustomDomain ? `/` : `/${props?.profile}/`} >
                                <img
                                    src={props?.profilePicture}
                                    alt={props?.displayName}
                                    width={75}
                                    height={75}
                                    quality={100}
                                    priority
                                />
                                <span>{props?.displayName}</span>
                            </a>
                        </div>

                        <div className="corner-top-left top">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                            </svg>
                        </div>
                        <div className="corner-top-left bottom">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                            </svg>
                        </div>
                                                
                        
                        <div className="nav-wrapp" >
                            <nav className='menu-inner'>
                                <ul className='level-1'>
                                    <li>
                                        <div className="menu-item-wrapper ">
                                            <span><a href={props?.hasCustomDomain ? '/' : `/${props?.profile}`}>Home</a></span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="menu-item-wrapper " >
                                            <span><a href={props?.hasCustomDomain ? '/contact' : `/${props?.profile}/contact`}>Contact</a></span>
                                        </div>
                                    </li>
                                    <li>
                                    </li>
                                </ul> 
                                {/* <div className="search-icon-mobile mobile-menu">
                                    <div className="formControl">
                                        <input type="text" placeholder='Search...'/>
                                    </div>
                                </div> */}
                            </nav>
                        </div>
                    </div>
                    <div className="header-actions">
                        <div className="search-box">
                                <div className='search-input-box'>
                                    <div className="corner-top-right top">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                                        </svg>
                                    </div>
                                </div>
                            <div className={`search-icon`} >
                                <span className="search-line main-line"></span>
                                <span className="search-circle"></span>
                                <span className="search-line second-line"></span>
                            </div>
                        </div>
                        <div className="menu-hamburger">
                            <div className="menu-toggle">
                                <span className="hamburger"></span>
                            </div>
                        </div>
                        <div className="subscribe-popup" id="subscribePopup">
                            <button className={`btn-common uk-button`} >
                                <a className={`btn-common uk-button`}>Subscribe</a>
                            </button>
                        </div>
                        <div className="corner-top-right top">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 0L0 20C0 8.95431 8.95431 0 20 0L0 0Z" fill="white"></path>
                            </svg>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}
